interface EnvLike {
  NEXT_PUBLIC_API_BASE_URL?: string
}

export function getWebApiBaseUrl(env?: EnvLike): string {
  const configuredBaseUrl =
    env?.NEXT_PUBLIC_API_BASE_URL?.trim() || process.env.NEXT_PUBLIC_API_BASE_URL?.trim()

  return configuredBaseUrl || 'http://localhost:13388/api/v1'
}

/**
 * Origin-only variant for callers using `@kiao-voice/api-client` —
 * that package's endpoints already include the `/api/v1/...` prefix in
 * their paths, so feeding them a baseUrl that also ends in `/api/v1`
 * would produce a `/api/v1/api/v1/...` 404. Strips a single trailing
 * `/api/v1` (with or without slash) from the configured base URL.
 */
export function getWebApiOrigin(env?: EnvLike): string {
  return getWebApiBaseUrl(env).replace(/\/api\/v1\/?$/, '')
}

/** The externally documented API surface, kept separate from internal docs. */
export function getWebApiDocsUrl(env?: EnvLike): string {
  return `${getWebApiOrigin(env)}/api/v1/public/docs`
}
